<template>
  <div class="container-controllercard" :class="{ selected: isSelected }" @click="emit('select', card.id)">
    <div class="container-group">
      <!-- 마이크선택 -->
      <div class="wrapper-contents first">
        <MCSDropdownMic
          v-model="card.microphone"
          :disabled="microphonesStore.isMicOn(selectedMicId)"
          :class="{ highlighted: !isSocketConnected }"
        />
      </div>

      <!-- 버튼컨트롤 -->
      <div class="wrapper-contents second">
        <button
          class="button-icon-text button-icon-text-big half"
          :class="[
            microphonesStore.isMicOn(selectedMicId) ? 'button-dim' : 'button-success',
            { notactive: !isSocketConnected },
          ]"
          :disabled="!isMicConnected"
          @click="toggleMic()"
        >
          <!-- 대기중 -->
          <template v-if="!microphonesStore.isMicOn(selectedMicId)">
            <IconOn class="icon-medium" />
            사용하기
          </template>

          <!-- 사용중 -->
          <template v-else>
            <span class="status-dot"></span>
            <span>사용중</span>
            <a class="link-error" @click.stop="toggleMic()">사용 중지</a>
          </template>
        </button>

        <button class="button-secondary half" :class="{ notactive: !isSocketConnected }" @click.stop="handleMuteAll">
          {{ '내 마이크만 켜기' }}
        </button>
      </div>

      <!--3.게이지조절-->
      <div class="wrapper-contents gauge" :class="{ notactive: !isSocketConnected }">
        <p class="smaller accent">
          {{ t('adjust_mic_sensitivity') }}
          <span v-if="microphonesStore.micSensitivityById[selectedMicId]">
            ({{ microphonesStore.micSensitivityById[selectedMicId] }})
          </span>
        </p>
        <MicInputControl
          v-model:volume-ratio="micSensitivityById[selectedMicId]"
          :effect="microphonesStore.micEffectById[selectedMicId]?.outerRadius"
          :max="20"
        />
      </div>
    </div>

    <div class="container-group">
      <!--1.언어선택-->
      <div class="wrapper-contents first">
        <MCSDropdownLanguage
          :id="card.id"
          v-model:language-selected="card.language"
          v-model:language-presets="languagePresets"
          :class="{ highlighted: !isSocketConnected }"
        />
      </div>

      <template v-if="userPresetList.length > 0">
        <div class="wrapper-contents second">
          <MCSDropdownUserPreset
            v-model="card.nickname"
            class="half"
            :class="{ highlighted: !isSocketConnected }"
            :user-preset-list="userPresetList"
            @change="changeNickname"
          />
          <input
            v-model="nickname"
            type="text"
            class="half"
            :class="{ notactive: !isSocketConnected }"
            placeholder="닉네임"
            @keyup.enter="changeNickname()"
          />
        </div>
        <div class="wrapper-contents">
          <button
            class="button-secondary button-full-width button-maxwidth"
            :class="{ notactive: !isSocketConnected }"
            @click="changeNickname()"
          >
            닉네임 변환
          </button>
          <button
            class="button-secondary button-full-width button-maxwidth"
            :class="{ notactive: !isSocketConnected }"
            @click="handleSwitchSpeaker"
          >
            문장완료
          </button>
        </div>
      </template>

      <!--2.언어버튼-->
      <template v-else>
        <div class="wrapper-contents second">
          <button
            class="button-secondary button-full-width"
            type="button"
            :class="{ notactive: !isSocketConnected }"
            :disabled="!languagePresets[0]"
            @click="selectLanguage(languagePresets[0])"
          >
            {{ languagePresets[0]?.name || '언어1' }}
          </button>

          <button
            class="button-secondary button-full-width"
            type="button"
            :class="{ notactive: !isSocketConnected }"
            :disabled="!languagePresets[1]"
            @click="selectLanguage(languagePresets[1])"
          >
            {{ languagePresets[1]?.name || '언어2' }}
          </button>

          <button
            class="button-secondary button-full-width"
            type="button"
            :class="{ notactive: !isSocketConnected }"
            :disabled="!languagePresets[2]"
            @click="selectLanguage(languagePresets[2])"
          >
            {{ languagePresets[2]?.name || '언어3' }}
          </button>

          <button
            class="button-secondary button-full-width"
            :class="{ notactive: !isSocketConnected }"
            @click="handleSwitchSpeaker"
          >
            문장완료
          </button>
        </div>

        <!--3.그외버튼-->
        <div class="wrapper-contents">
          <input
            v-model="card.nickname"
            class="input-full-width"
            type="text"
            :class="{ notactive: !isSocketConnected }"
            placeholder="닉네임"
          />
          <button class="button-secondary m-btn" :class="{ notactive: !isSocketConnected }" @click="changeNickname()">
            닉네임 변환
          </button>
        </div>
      </template>
    </div>
    <!--삭제버튼-->
    <button
      class="button-glass-dark button-icon button-icon-small button-rounded delete-card-button"
      @click.stop="deleteCard"
    >
      <IconTrashcan class="icon-white" />
    </button>

    <!--패널-->
    <PeekingPanel
      v-model="isVisiblePanel"
      width="18rem"
      :style="{
        top: '50%',
        transform: isVisiblePanel
          ? 'translateY(-50%) translateX(0)'
          : 'translateY(-50%) translateX(calc(100% - 1.5rem))',
      }"
    >
      <div class="container-panel">
        <div v-if="!userPresetList.length" class="container-group login">
          <input
            v-model="card.userId"
            type="text"
            :disabled="isSocketConnected"
            :class="{ highlighted: !isSocketConnected }"
            placeholder="아이디"
            @input="resetSocketStatusMessage"
          />
          <div class="wrapper-contents">
            <input
              v-model="card.nickname"
              class="input-full-width"
              type="text"
              :disabled="isSocketConnected"
              :class="{ highlighted: !isSocketConnected }"
              placeholder="닉네임 (선택)"
              @keyup.enter="connectSocket(false)"
            />
          </div>
        </div>
        <div class="container-group login">
          <template v-if="!isSocketConnected">
            <button
              v-if="socketConnectionResponse === 1030 && socketStatusMessage"
              class="button-primary m-btn"
              :disabled="!isValidForm"
              @click.stop="connectSocket(true)"
            >
              강제연결
            </button>
            <button v-else class="button-primary m-btn" :disabled="!isValidForm" @click.stop="connectSocket(false)">
              연결하기
            </button>
            <div class="status-message">
              <p v-if="socketStatusMessage" class="error-message">
                <InfoIcon class="icon-error" />
                {{ socketStatusMessage }}
              </p>
            </div>
          </template>
          <template v-else>
            <div class="status-message">
              <span class="status-dot"></span>
              <p>연결됨</p>
              <a @click.stop="disconnectSocket(true)">연결 끊기</a>
            </div>
          </template>
        </div>
      </div>
    </PeekingPanel>
  </div>
</template>

<script setup lang="ts">
import { useIntervalFn } from '@vueuse/core';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import { isEmpty } from 'lodash';
import { storeToRefs } from 'pinia';

import api from '@/api';
import MicInputControl from '@/components/domains/chat/common/MicInputControl.vue';
import InfoIcon from '@/components/icons/IconInfo.vue';
import IconOn from '@/components/icons/IconOn.vue';
import IconTrashcan from '@/components/icons/IconTrashcan.vue';
import MCSDropdownLanguage from '@/components/shared/composite/MCSDropdownLanguage.vue';
import MCSDropdownMic from '@/components/shared/composite/MCSDropdownMic.vue';
import MCSDropdownUserPreset from '@/components/shared/composite/MCSDropdownUserPreset.vue';
import PeekingPanel from '@/components/shared/composite/PeekingPanel.vue';
import { useCallStore } from '@/stores/call';
import { useMicrophonesStore } from '@/stores/microphones';
import { useSocketStore } from '@/stores/socket';
import { useSocketsStore } from '@/stores/sockets';
import { useToastStore } from '@/stores/toast';
import { IMcbCard, Language } from '@/types/components';
import { IResponseMcsSubUser } from '@/types/response';
import { ConnectionEntry } from '@/types/socket';
import convertASCII from '@/utils/convertASCII';
import { getBrowserAndDeviceInfo } from '@/utils/device';
import { base64UrlSafeToString, stringToBase64UrlSafe } from '@/utils/encryptor';

const card = defineModel<IMcbCard>({
  required: true,
  default: () => ({
    id: '',
    userId: '',
    nickname: '',
    microphone: {},
    language: {},
  }),
});

const props = withDefaults(
  defineProps<{
    cards: IMcbCard[];
    userPresetList: IResponseMcsSubUser[];
    isSelected: boolean;
  }>(),
  {
    cards: () => [],
    userPresetList: () => [],
    isSelected: false,
  }
);

const emit = defineEmits<{
  select: [id: string];
  delete: [];
}>();

const { t } = useI18n();

const microphonesStore = useMicrophonesStore();
const callStore = useCallStore();

const { micSensitivityById } = storeToRefs(microphonesStore);

const route = useRoute();

const socketStore = useSocketStore();
const socketsStore = useSocketsStore();
const toastStore = useToastStore();

const languagePresets = ref<Language[]>([]); // 언어 프리셋
const socketStatusMessage = ref<string>(''); // 소켓 상태 메시지
const isVisiblePanel = ref<boolean>(true); // 슬라이딩 패널 노출 여부

const nickname = ref<string>('');
const shouldRestartMic = ref<boolean>(false);

const isValidForm = computed<boolean>(() => {
  const { id = '', userId = '', language = {}, microphone = {} } = card.value;
  return !!(id && userId) && !isEmpty(language) && !isEmpty(microphone);
});

// 선택한 마이크 ID
const selectedMicId = computed<string>(() => {
  const { microphone: { id = '' } = { id: '' } } = card.value;
  return id;
});

const isMicConnected = computed<boolean>(() => {
  const { isConnected = false } = microphonesStore.microphones.find(({ id }) => selectedMicId.value === id) || {};
  return isConnected;
});

const currentSocket = computed<ConnectionEntry>(() => {
  return socketsStore.connections.get(card.value.id) || ({} as ConnectionEntry);
});

const socketState = computed<string>(() => {
  return currentSocket.value.state ?? '';
});

// 소켓 연결 여부
const isSocketConnected = computed<boolean>(() => {
  return (
    socketState.value === 'OPEN' && !!currentSocket.value.ws && currentSocket.value.ws.readyState === WebSocket.OPEN
  );
});

// 소켓 연결 여부
const socketConnectionResponse = computed<number>(() => {
  return currentSocket.value.connectionResponse ?? -1;
});

// 카드 삭제
const deleteCard = async () => {
  if (isSocketConnected.value) {
    disconnectSocket(true);
  }
  if (microphonesStore.isMicOn(selectedMicId.value)) {
    await microphonesStore.stopMics([selectedMicId.value]);
  }
  emit('delete');
};

const handleMicEvent = (data) => {
  if (!isSocketConnected.value || !navigator.onLine) {
    handleOffline();
  } else {
    const audioBytes = new Float32Array(data);
    socketsStore.sendMessageAudioStreamChunk(card.value.id, new Uint8Array(audioBytes.buffer), 'as');
  }
};

// 마이크 on/off
const toggleMic = (onlyThis: boolean = false) => {
  if (!isSocketConnected.value) {
    handleOffline();
    microphonesStore.stopMics([selectedMicId.value]);
    socketsStore.sendMessageAudioStreamEnd(card.value.id);
    return;
  }

  if (!microphonesStore.isMicOn(selectedMicId.value)) {
    socketsStore.sendMessageAudioStreamStart(card.value.id);
    microphonesStore.setMicEventById(selectedMicId.value, handleMicEvent);
    microphonesStore.startMics([selectedMicId.value]);
    shouldRestartMic.value = true;
    if (onlyThis) {
      toastStore.info(`${card.value.microphone.label}만 사용합니다.`);
    } else {
      toastStore.info(`${card.value.microphone.label} 사용을 시작합니다.`);
    }
  } else {
    microphonesStore.stopMics([selectedMicId.value]);
    socketsStore.sendMessageAudioStreamEnd(card.value.id);
    shouldRestartMic.value = false;
  }
};

const setSocketStatusMessage = (): boolean => {
  const { loginId = '' } = JSON.parse(localStorage.getItem('userInfo') || '') || {
    loginId: '',
  };
  let message = '';

  if (!navigator.onLine) {
    message = '연결 중인 네크워크가 없습니다.';
  } else if (card.value.userId === loginId) {
    message = '현재 로그인 중인 아이디입니다.';
  } else if (props.cards.some(({ userId, id }) => card.value.id !== id && userId === card.value.userId)) {
    message = '사용 중인 아이디입니다.';
  }

  return !!(socketStatusMessage.value = message);
};

const resetSocketStatusMessage = () => {
  if (socketStatusMessage.value) {
    socketStatusMessage.value = '';
  }
};

/**
 * @desc 소켓 활성화
 * @param isEvictMyself - 강제연결 여부
 * */
const connectSocket = async (isEvictMyself: boolean = false) => {
  if (!isSocketConnected.value && setSocketStatusMessage()) {
    return;
  }
  card.value.nickname = card.value.nickname.trim();

  const url = card.value.nickname
    ? `/api/partner/auth/subUser?nickname=${card.value.nickname}`
    : `/api/partner/auth/subUser`;

  await api
    .post(url, null, {
      headers: {
        Userid: card.value.userId,
      },
    })
    .then(async ({ data }) => {
      if (!data.token || !data.userId) {
        throw new Error();
      }
      if (!card.value.nickname && data.userId) {
        await requestNickname(data.userId);
      }
      socketsStore.setConnectInfo(card.value.id, {
        userId: data.userId,
        isRegister: '0',
        isTssOn: '0',
        voiceId: '0',
        chatId: socketStore.selectedChatId,
        languageCode: card.value.language.code,
        nickname: stringToBase64UrlSafe(card.value.nickname),
        isPartnerPerson: '0',
        longVoice: '0',
        code: route.params.code.toString(),
        token: `Bearer ${data.token}`,
        evictMySelf: isEvictMyself ? '1' : '0',
        callType: callStore.qrCodeInfo.callType,
        connectionType: 'GENERAL',
        agent: JSON.stringify(getBrowserAndDeviceInfo()),
      });
      await socketsStore.setupWebSocket(card.value.id);
      if (isSocketConnected.value) {
        isVisiblePanel.value = false;
      }
    })
    .catch((error) => {
      let messageSocketFail = '';
      if (error.errorCode) {
        switch (error.errorCode) {
          case 1004:
            messageSocketFail = '이 파트너사에는 등록되지 않은 아이디입니다.';
            break;
          default:
            messageSocketFail = '연결을 실패했습니다.';
            break;
        }
      }
      socketStatusMessage.value = messageSocketFail;
      toastStore.error(messageSocketFail);
    });
};

/**
 * @desc 소켓 재연결
 * */
const reconnectSocket = async () => {
  if (socketState.value === 'CLOSED') {
    await connectSocket(true);
  } else {
    clearSocketInterval();
  }
};
const { pause: clearSocketInterval, resume: startSocketInterval } = useIntervalFn(reconnectSocket, 1000);

/**
 * @desc 소켓 비활성화
 * */
const disconnectSocket = (isForce: boolean = false) => {
  socketsStore.close(card.value.id, isForce);
  isVisiblePanel.value = true;
  if (microphonesStore.isMicOn(selectedMicId.value)) {
    toggleMic();
  }
};

const handleMuteAll = () => {
  const ids = microphonesStore.selectedMicrophoneIds.filter((id) => id !== selectedMicId.value);
  props.cards.forEach((card) => {
    if (ids.includes(card.microphone.id)) {
      socketsStore.sendMessageAudioStreamEnd(card.id);
    }
  });
  microphonesStore.stopMics(ids);
  if (!microphonesStore.isMicOn(selectedMicId.value)) {
    toggleMic(true);
  }
};

const handleSwitchSpeaker = () => {
  if (!isSocketConnected.value) {
    handleOffline();
    return;
  }

  const messageLength = ''.padStart(8, '0');
  const payload = new Uint8Array([...convertASCII('sw'), ...new TextEncoder().encode(messageLength)]);
  socketsStore.sendRaw(card.value.id, payload);
  toastStore.info('새로운 문장으로 전환됩니다.');
};

const selectLanguage = (language) => {
  if (!isSocketConnected.value) {
    handleOffline();
    return;
  }

  card.value.language = language;
  socketsStore.sendMessageChangeLanguage(card.value.id, language.code);
};

const changeNickname = async (person?: IResponseMcsSubUser, isAll = false) => {
  socketStatusMessage.value = '';

  if (nickname.value) {
    card.value.nickname = nickname.value;
    nickname.value = '';
  }

  if (!card.value.nickname) {
    return;
  }

  if (socketsStore.connections.has(card.value.id) && isSocketConnected.value) {
    socketsStore.sendMessageCn(card.value.id, {
      nickname: stringToBase64UrlSafe(card.value.nickname).toString(),
      isAll,
    });
    toastStore.info(`닉네임이 ${card.value.nickname}(으)로 변경되었습니다.`);
  } else if (person) {
    card.value.userId = person.loginId;
  }
};

const requestNickname = async (userId: string) => {
  if (userId) {
    const { data } = await api.get('/api/user/info/web', { params: { userId } });
    if (data?.nickname) {
      card.value.nickname = base64UrlSafeToString(data.nickname);
    }
  }
};

// 인터넷 연결 대응 로직
const handleOnline = async () => {
  await connectSocket(true);
  if (shouldRestartMic.value && !microphonesStore.isMicOn(selectedMicId.value)) {
    toggleMic();
  }
};

// 인터넷 연결 대응 로직
const handleOffline = async () => {
  if (isSocketConnected.value) {
    disconnectSocket(true);
    socketStatusMessage.value = '인터넷 연결이 끊어졌습니다.';
  }
};

const handleBeforeUnload = () => {
  disconnectSocket(true);
};

onMounted(() => {
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);
  window.addEventListener('beforeunload', handleBeforeUnload);
});

onUnmounted(() => {
  window.removeEventListener('online', handleOnline);
  window.removeEventListener('offline', handleOffline);
  window.removeEventListener('beforeunload', handleBeforeUnload);
});

watch(
  () => socketState.value,
  (state) => {
    switch (state) {
      case 'CLOSE':
        if (socketStatusMessage.value) {
          setTimeout(startSocketInterval, 3000);
        }
        break;
    }
  }
);

watch(
  () => micSensitivityById.value[selectedMicId.value],
  () => {
    microphonesStore.controlGainById(selectedMicId.value);
  }
);

watch(
  () => isMicConnected.value,
  (val) => {
    if (!val && microphonesStore.isMicOn(selectedMicId.value)) {
      toggleMic();
    }
  }
);

// 소켓메시지
watch(
  () => socketConnectionResponse.value,
  async (val) => {
    switch (val) {
      case -1:
      case 0:
      case 1:
      case 2:
        socketStatusMessage.value = '';
        break;
      case 1016: // 잘못된 코드 요청
        socketStatusMessage.value = '잘못된 코드 요청입니다.';
        disconnectSocket();
        break;
      case 1029: // 사용량 초과
        socketStatusMessage.value = '사용량이 초과되었습니다.';
        disconnectSocket();
        break;
      case 1030: // 동시 접속시
        socketStatusMessage.value = '동시 접속중 입니다.';
        disconnectSocket();
        break;
      case 4010: // 인증 실패
        socketStatusMessage.value = '인증을 실패히였습니다.';
        disconnectSocket();
        break;
      case 1026: // 이미 통역 중일 때 or 동시 접속자 초과
        socketStatusMessage.value = '동시 접속자 초과하였습니다.';
        disconnectSocket();
        break;
      case 1027: // 이미 종료된 통역일 때
        socketStatusMessage.value = '이미 종료된 통역입니다.';
        disconnectSocket();
        break;
      case 1023: // 호스트 접속이 안되어있을 때 (FAIR / CONFERENCE)
        socketStatusMessage.value = '호스트 미접속중 입니다.';
        disconnectSocket();
        break;
      default: // 나머지 에러
        disconnectSocket();
        break;
    }
  },
  { immediate: true }
);
</script>

<style scoped lang="scss">
.container-controllercard {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  min-width: 55rem;
  height: fit-content;
  flex-shrink: 0;
  padding: 0.5rem 3rem 0.5rem 0.5rem;
  gap: 0.5rem;
  align-items: flex-start;
  background: var(--surface-default);
  border-radius: 12px;
  box-shadow: $shadow-card;
  overflow: hidden;

  &:hover {
    outline: 2px solid var(--border-primary);
  }

  &.selected {
    outline: 2px solid var(--border-primary);
  }
}

.delete-card-button {
  position: absolute;
  bottom: 1rem;
  right: 0.5rem;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
  z-index: $z-tooltip;
  cursor: pointer;
}

.button-maxwidth {
  max-width: 12rem;
}

.container-controllercard:hover .delete-card-button {
  opacity: 1;
  pointer-events: auto;
}

.container-group {
  position: relative;
  display: flex;
  width: 100%;
  flex: 1;
  gap: $spacing2;
}

.login {
  flex-direction: column;
  gap: 0.75rem;
}

.wrapper-contents {
  width: 100%;
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.first {
  width: 13rem;
  flex-shrink: 0;
}

.second {
  width: 24.5rem;
  flex-shrink: 0;

  .half {
    width: 12rem;
    min-width: 12rem;
    max-width: 12rem;
    flex-shrink: 0;
  }
}

.gauge {
  flex-direction: column;
  gap: 0.5rem;
  align-items: unset;
}

.container-panel {
  display: flex;
  width: 100%;
  gap: 1em;
}

.status-dot {
  width: 0.75rem;
  height: 0.75rem;
  background-color: var(--success);
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;
}

.status-message {
  height: 3rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.notactive {
  opacity: 0.2;
  pointer-events: none;
}

.highlighted {
  // border: 2px solid var(--border-primary-dim);
  border-radius: 8px;
}

.divider {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.error-message {
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
  color: var(--color-red);
  margin-top: 0.25rem;
  gap: 0.25rem;
}

button {
  white-space: nowrap;
}

input {
  max-height: 3rem;
}
.container-controllercard {
  button {
    height: 44px !important;
  }
}
</style>
